export default {
  data() {
    return {
      messageListeners: [],
    }
  },
  mounted() {
    window.parent.postMessage(
      {
        status: 'vue-loaded',
      },
      window.location.origin,
    )
  },
  unmounted() {
    this.messageListeners.forEach((listener) => {
      window.removeEventListener('message', listener, false)
    })
  },
  computed: {
    inIframe() {
      try {
        return window.self !== window.top
      } catch (e) {
        return true
      }
    },
  },
  methods: {
    registerProcessCallback(callback) {
      this.registerListener('vue-process', callback)
    },
    registerListener(eventStatus, callback) {
      const listener = (evt) => {
        if (evt.data.status === eventStatus) {
          callback(evt)
        }
      }
      window.addEventListener('message', listener, false)
      this.messageListeners.push(listener)
    },
  },
}
